import { webappDisplayUrl } from "@sagot/constants";
import { useTranslation } from "@sagot/i18n";
import { Icon } from "@sagot/ui";
import { slugify, useSlugAvailability } from "../lib/slug";

/** "Your workspace URL: <slug>.<domain>" with a live availability check. */
export function WorkspaceUrlHint({ name }: { name: string }) {
  const { t } = useTranslation();
  const slug = slugify(name);
  const status = useSlugAvailability(slug);
  return (
    <span aria-live="polite">
      {t("auth.register.workspaceUrl")} <span className="font-mono text-fg-muted">{webappDisplayUrl(slug || "your-workspace")}</span>
      {status === "checking" ? <span className="ml-1.5">{t("auth.register.slugChecking")}</span> : null}
      {status === "available" ? (
        <span className="ml-1.5 inline-flex items-center gap-1 font-semibold text-success">
          <Icon name="check-circle" className="size-3.5" />
          {t("auth.register.slugAvailable")}
        </span>
      ) : null}
      {status === "taken" || status === "reserved" ? (
        <span className="ml-1.5 inline-flex items-center gap-1 font-semibold text-warning">
          <Icon name="alert-triangle" className="size-3.5" />
          {t("auth.register.slugTaken")}
        </span>
      ) : null}
    </span>
  );
}
